import { defineNuxtPlugin, useRuntimeConfig, useHead, useRoute } from "#imports";

export default defineNuxtPlugin((nuxtApp) => {
	const appEnv = useRuntimeConfig().public.appEnv;

	if (process.client) {
		const ignoreRoutes = ['/widget/instituicao','/widget/allinstitutions', '/widget/todas-marcas'];
		const route = useRoute()
		
		if (!ignoreRoutes.includes(route.path)) {
			useHead(
				{
					script: [
						{
							key: 'gtm',
							children: `
								(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
								new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
								j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
								'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
								})(window,document,'script','dataLayer','GTM-K669S3X');
								window.dataLayer = window.dataLayer || [];
								function gtag(){
									dataLayer.push(arguments);
								}
								gtag('js', new Date());
								gtag('config', 'AW-10848357209');
								(window.gtag_old || []).forEach((evt) => window.gtag('event', ...evt));
							`,
							type: 'text/javascript'
						}
						// ,{
						// 	key: 'tid',
						// 	children: `
						// 	window.Tracker = {
						// 		send(...args) {
						// 			window.tid_old = window.tid_old || [];
						// 			window.tid_old.push(args);
						// 		}
						// 	};
						// 	(function (w, d, src, o=null) {
						// 		const el = d.createElement("script");
						// 		el.src = src;el.async = true;el.onload = o || function () {};
						// 		d.getElementsByTagName("script")[0].appendChild(el);
						// 	})(window, document, "https://vaidebolsa.com.br/assets/tracker.js", function() {
						// 		(window.tid_old || []).forEach((args) => Tracker.send(...args)); 
						// 	});
						// `,
						// 	type: 'text/javascript'
						// }
					]
				}
			);
		}
	}
});
